import { z } from "zod";
import { vehicleTypeSchema, registrationDataSchema } from "../_shared";

export const createVehicleRequestSchema = z.object({
  registrationNumber: z.string().nullable(),
  vehicleType: vehicleTypeSchema,
  company: z.uuid(),
  reference: z.string().nullable(),
  registrationData: registrationDataSchema.optional(),
});

export type CreateVehicleRequest = z.infer<typeof createVehicleRequestSchema>;
